import React, { useEffect } from "react";
import "./Component4.css";
import secured from "../img/shield_8280286.png";
import car from "../img/toy-car_11940630.png";
import cost from "../img/goal_12352348.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Component4 = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <div className="component4" data-aos="flip-right">
      <div className="div4">
        <h1 className="h22">Why Choose Us?</h1>
        <p className="p22">
          We have professional and personalized transportation services to make
          your journey more than a destination. We also provide rides that are
          super safe, luxurious and prompt.
        </p>
      </div>
      <div className="flex_div">
        <div className="flex">
          <div className="flexFlex">
            <img className="img2" src={secured} alt="" />
            <p className="p4">
              Our vehicles are maant to be the highest standard of safety.{" "}
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="flexFlex">
            <img className="img2" src={car} alt="" />
            <p className="p4">
              <span>BENTRACO LOGISTICS</span> provides high-quality private car
              services under the name of extravagance chauffeured car services.
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="flexFlex">
            <img className="img2" src={cost} alt="" />
            <p className="p4">
              We provide professional and affordable luxury limousine services.
              You can contact us to book your ride and our team will update you
              with your riding details.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component4;
